import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { config } from '../ssoconfig/appconfig';
import { environment } from 'src/environments/environment';

// BEFORE ACCESS TOKEN PROCESS
@Injectable({
  providedIn: 'root',
})
export class SsoLoginService {
  private readonly verifierKey = 'sso_code_verifier';
  private readonly challengeKey = 'sso_code_challenge';
  private readonly tokenKey = 'access_token';


  constructor() { }

  private generateRandomString(length: number = 20): string {
    const chars =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * chars.length);
      result += chars[randomIndex];
    }
    return result;
  }

  private hashString(str: string): string {
    const fullHash = CryptoJS.SHA256(str).toString(CryptoJS.enc.Hex);
    console.log('str',str);
    console.log('hash',fullHash);
    return fullHash.substring(0, 32);
  }

  login(): void {
    const codeVerifier = this.generateRandomString(20);
    const codeChallenge = this.hashString(codeVerifier);

    localStorage.setItem(this.verifierKey, codeVerifier);
    localStorage.setItem(this.challengeKey, codeChallenge);

    let redirectUrl = ``;
    if(environment.production)redirectUrl = `${environment.ssoURL}?appId=${config.appId}&codeChallenge=${codeChallenge}`;
    else redirectUrl = `${environment.ssoURL}?appId=${config.appId}&codeChallenge=${codeChallenge}&returnUrl=${environment.localhostUrl}`;
    window.location.href = redirectUrl;

  }

  getStoredVerifier(): string | null {
    return localStorage.getItem(this.verifierKey);
  }

  getStoredChallenge(): string | null {
    return localStorage.getItem(this.challengeKey);
  }
}
